import { useNavigate } from "react-router"
import "./Nav.css"

export default function Nav() {
    const navigate = useNavigate();

    const handleShopClick = () => {
        navigate("/shop");
    }

    const handleAboutClick = () => {
        navigate("/about");
    }

    return (
        <ul className="nav">
            <li onClick={handleShopClick}>Shop</li>
            {/* <li>Terrain</li>
            <li>Props</li> */}
            <li onClick={handleAboutClick}>About</li>
        </ul>
    )
}